import { EarthPlusIcon } from './EarthPlusIcon';

/**
 * author: Muhammet Balsoy
 * id 046CC069-3771-4172-A9E6-F8D18161551F
 * name earth-plus
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-plus.svg
 * tags
 * - Navigation 
 */
export const GlobePlusIcon = EarthPlusIcon;
export default GlobePlusIcon